import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { Materials_FlowService } from './Materials.flow.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';
import { Reports_FlowService } from './Reports.flow.index';
import { FootprintEdi_FlowService } from './FootprintEdi.flow.index';

import { app_custom_auto_process_zagg_ebp_ordersService } from './app.flow.index';
import { app_custom_substitution_sales_order_flowService } from './app.flow.index';
import { app_hello_worldService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.Materials = this.injector.get(Materials_FlowService);
    this.SalesOrders = this.injector.get(SalesOrders_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
    this.Reports = this.injector.get(Reports_FlowService);
    this.FootprintEdi = this.injector.get(FootprintEdi_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public Materials: Materials_FlowService;
    public SalesOrders: SalesOrders_FlowService;
    public Notifications: Notifications_FlowService;
    public Inventory: Inventory_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
    public Reports: Reports_FlowService;
    public FootprintEdi: FootprintEdi_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _custom_auto_process_zagg_ebp_orders: app_custom_auto_process_zagg_ebp_ordersService;
  public async custom_auto_process_zagg_ebp_orders($inParams: {  }): Promise<void> {
    if(!this._custom_auto_process_zagg_ebp_orders) { 
      this._custom_auto_process_zagg_ebp_orders = this.injector.get(app_custom_auto_process_zagg_ebp_ordersService);
    }
    return this._custom_auto_process_zagg_ebp_orders.run($inParams);
  }
   
   

   
 
  private _custom_substitution_sales_order_flow: app_custom_substitution_sales_order_flowService;
  public async custom_substitution_sales_order_flow($inParams: { orderId: number }): Promise< { reason?: string }> {
    if(!this._custom_substitution_sales_order_flow) { 
      this._custom_substitution_sales_order_flow = this.injector.get(app_custom_substitution_sales_order_flowService);
    }
    return this._custom_substitution_sales_order_flow.run($inParams);
  }
   
   

   
 
  private _hello_world: app_hello_worldService;
  public async hello_world($inParams: { name?: string }): Promise< { message?: string }> {
    if(!this._hello_world) { 
      this._hello_world = this.injector.get(app_hello_worldService);
    }
    return this._hello_world.run($inParams);
  }
   
   

   
}
